let base_index = 5000
module.exports = {
  getZIndex (){
    return base_index++
  }
}



// WEBPACK FOOTER //
// ./static/components/max-z-index/index.js